export const ASSETS = {
  "backgrounds": {
    "altar": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/f624e261ed694147984f7917b873f011/preview/assets/backgrounds/altar.png",
      "height": 1080,
      "transparent": false,
      "width": 1920
    },
    "battleArena": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/aa768a94b1024ea3b59c83a9fc7a45f5/preview/assets/backgrounds/battleArena.png",
      "height": 1080,
      "transparent": false,
      "width": 1920
    },
    "battleBg": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/ae297dc491dc4bbfa576c6bbdc58893e/c011003fa6d64236aa7556e4339d1f97/preview/assets/backgrounds/battleBg.png",
      "width": 1920,
      "height": 1080,
      "transparent": false
    },
    "lair": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/f624e261ed694147984f7917b873f011/preview/assets/backgrounds/lair.png",
      "height": 1080,
      "transparent": false,
      "width": 1920
    },
    "library": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/f624e261ed694147984f7917b873f011/preview/assets/backgrounds/library.png",
      "height": 1080,
      "transparent": false,
      "width": 1920
    },
    "market": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/f624e261ed694147984f7917b873f011/preview/assets/backgrounds/market.png",
      "height": 1080,
      "transparent": false,
      "width": 1920
    },
    "mythical": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/066fa0a8f446430b878771e809b6cedb/preview/assets/backgrounds/mythical-bg.png",
      "height": 1080,
      "width": 1920
    },
    "tome": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/f624e261ed694147984f7917b873f011/preview/assets/backgrounds/tome.png",
      "height": 1080,
      "transparent": false,
      "width": 1920
    }
  },
  "cards": {
    "cardBack": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/ae297dc491dc4bbfa576c6bbdc58893e/c011003fa6d64236aa7556e4339d1f97/preview/assets/cards/cardBack.png",
      "width": 100,
      "height": 150,
      "transparent": false
    }
  },
  "competitors": {
    "Adept": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/aa768a94b1024ea3b59c83a9fc7a45f5/preview/assets/competitors/Adept.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "Champion": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/aa768a94b1024ea3b59c83a9fc7a45f5/preview/assets/competitors/Champion.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "Master": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/aa768a94b1024ea3b59c83a9fc7a45f5/preview/assets/competitors/Master.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "Rookie": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/aa768a94b1024ea3b59c83a9fc7a45f5/preview/assets/competitors/Rookie.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "Veteran": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/aa768a94b1024ea3b59c83a9fc7a45f5/preview/assets/competitors/Veteran.png",
      "height": 100,
      "transparent": true,
      "width": 100
    }
  },
  "dragons": {
    "AbyssKing": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/2b973aae7f004a01acc25dc5b7e0326c/preview/assets/dragons/AbyssKing.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "AbyssShell": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/29c9debe2a3e4bd1a99b6d15919ceb62/preview/assets/dragons/abyss-shell.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "AbyssalOverlord": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/89ae48217d1345f0a667415861203d6a/preview/assets/dragons/AbyssalOverlord.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "Air": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/c089f59db2a9432b8a66e4d03f491108/preview/assets/dragons/air.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "AquaBite": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/7bd34707ca4d4ef38b21a373cbaab8bc/preview/assets/dragons/aqua-bite.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "ArcStorm": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/e4bb806470aa438c84ca56c03662457f/preview/assets/dragons/ArcStorm.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "AshenWarlord": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/89ae48217d1345f0a667415861203d6a/preview/assets/dragons/AshenWarlord.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "AuroraSentinel": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/89ae48217d1345f0a667415861203d6a/preview/assets/dragons/AuroraSentinel.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "BeaconShield": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/d5b920595192477ca4cf3ae89fdf63cf/preview/assets/dragons/beacon-shield.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "BlazeOverlord": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/2b973aae7f004a01acc25dc5b7e0326c/preview/assets/dragons/BlazeOverlord.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "BlazingTalon": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/d5b920595192477ca4cf3ae89fdf63cf/preview/assets/dragons/blazing-talon.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "BoltGuard": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/7bd34707ca4d4ef38b21a373cbaab8bc/preview/assets/dragons/bolt-guard.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "BoulderMaw": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/d5b920595192477ca4cf3ae89fdf63cf/preview/assets/dragons/boulder-maw.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "BreezeWing": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/7bd34707ca4d4ef38b21a373cbaab8bc/preview/assets/dragons/breeze-wing.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "CelestialBarrier": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/e4bb806470aa438c84ca56c03662457f/preview/assets/dragons/CelestialBarrier.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "CelestialOverlord": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/2b973aae7f004a01acc25dc5b7e0326c/preview/assets/dragons/CelestialOverlord.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "CinderGuard": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/29c9debe2a3e4bd1a99b6d15919ceb62/preview/assets/dragons/cinder-guard.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "CloudWall": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/d5b920595192477ca4cf3ae89fdf63cf/preview/assets/dragons/cloud-wall.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "ColossusCore": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/89ae48217d1345f0a667415861203d6a/preview/assets/dragons/ColossusCore.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "CrystalHide": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/29c9debe2a3e4bd1a99b6d15919ceb62/preview/assets/dragons/crystal-hide.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "CycloneTyrant": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/89ae48217d1345f0a667415861203d6a/preview/assets/dragons/CycloneTyrant.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "DarkBulwark": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/d5b920595192477ca4cf3ae89fdf63cf/preview/assets/dragons/dark-bulwark.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "Darkness": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/c089f59db2a9432b8a66e4d03f491108/preview/assets/dragons/darkness.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "DeepCurrent": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/d5b920595192477ca4cf3ae89fdf63cf/preview/assets/dragons/deep-current.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "DuskTalon": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/29c9debe2a3e4bd1a99b6d15919ceb62/preview/assets/dragons/dusk-talon.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "Earth": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/c089f59db2a9432b8a66e4d03f491108/preview/assets/dragons/earth.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "EclipseHorror": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/89ae48217d1345f0a667415861203d6a/preview/assets/dragons/EclipseHorror.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "Electricity": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/c089f59db2a9432b8a66e4d03f491108/preview/assets/dragons/electricity.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "EmberFang": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/7bd34707ca4d4ef38b21a373cbaab8bc/preview/assets/dragons/ember-fang.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "Fire": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/c089f59db2a9432b8a66e4d03f491108/preview/assets/dragons/fire.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "FlameGuard": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/7bd34707ca4d4ef38b21a373cbaab8bc/preview/assets/dragons/flame-guard.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "FrostFin": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/29c9debe2a3e4bd1a99b6d15919ceb62/preview/assets/dragons/frost-fin.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "GaleProtector": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/7bd34707ca4d4ef38b21a373cbaab8bc/preview/assets/dragons/gale-protector.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "GlowTalon": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/7bd34707ca4d4ef38b21a373cbaab8bc/preview/assets/dragons/glow-talon.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "GraniteShell": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/d5b920595192477ca4cf3ae89fdf63cf/preview/assets/dragons/granite-shell.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "HaloBastion": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/e4bb806470aa438c84ca56c03662457f/preview/assets/dragons/HaloBastion.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "InfernalDrake": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/e4bb806470aa438c84ca56c03662457f/preview/assets/dragons/InfernalDrake.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "InfernoScale": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/d5b920595192477ca4cf3ae89fdf63cf/preview/assets/dragons/inferno-scale.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "InfernoSovereign": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/2b973aae7f004a01acc25dc5b7e0326c/preview/assets/dragons/InfernoSovereign.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "IonWarden": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/89ae48217d1345f0a667415861203d6a/preview/assets/dragons/IonWarden.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "IronJaw": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/29c9debe2a3e4bd1a99b6d15919ceb62/preview/assets/dragons/iron-jaw.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "LeviathanGuard": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/e4bb806470aa438c84ca56c03662457f/preview/assets/dragons/LeviathanGuard.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "Light": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/c089f59db2a9432b8a66e4d03f491108/preview/assets/dragons/light.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "LightningOverlord": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/2b973aae7f004a01acc25dc5b7e0326c/preview/assets/dragons/LightningOverlord.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "LuminousFang": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/29c9debe2a3e4bd1a99b6d15919ceb62/preview/assets/dragons/luminous-fang.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "MaelstromLeviathan": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/89ae48217d1345f0a667415861203d6a/preview/assets/dragons/MaelstromLeviathan.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "MagmaWing": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/29c9debe2a3e4bd1a99b6d15919ceb62/preview/assets/dragons/magma-wing.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "NetherColossus": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/89ae48217d1345f0a667415861203d6a/preview/assets/dragons/NetherColossus.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "NightColossus": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/e4bb806470aa438c84ca56c03662457f/preview/assets/dragons/NightColossus.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "NightFang": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/d5b920595192477ca4cf3ae89fdf63cf/preview/assets/dragons/night-fang.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "ObsidianMaw": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/e4bb806470aa438c84ca56c03662457f/preview/assets/dragons/ObsidianMaw.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "OceanMonarch": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/2b973aae7f004a01acc25dc5b7e0326c/preview/assets/dragons/OceanMonarch.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "PlasmaGuard": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/29c9debe2a3e4bd1a99b6d15919ceb62/preview/assets/dragons/plasma-guard.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "PrismShell": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/29c9debe2a3e4bd1a99b6d15919ceb62/preview/assets/dragons/prism-shell.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "PyreSentinel": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/e4bb806470aa438c84ca56c03662457f/preview/assets/dragons/PyreSentinel.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "RadiantDrake": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/e4bb806470aa438c84ca56c03662457f/preview/assets/dragons/RadiantDrake.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "RadiantShell": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/7bd34707ca4d4ef38b21a373cbaab8bc/preview/assets/dragons/radiant-shell.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "RockHide": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/7bd34707ca4d4ef38b21a373cbaab8bc/preview/assets/dragons/rock-hide.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "ShadeClaw": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/7bd34707ca4d4ef38b21a373cbaab8bc/preview/assets/dragons/shade-claw.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "ShadowEmperor": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/2b973aae7f004a01acc25dc5b7e0326c/preview/assets/dragons/ShadowEmperor.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "ShadowFortress": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/29c9debe2a3e4bd1a99b6d15919ceb62/preview/assets/dragons/shadow-fortress.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "ShadowGuard": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/7bd34707ca4d4ef38b21a373cbaab8bc/preview/assets/dragons/shadow-guard.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "SkyCutter": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/d5b920595192477ca4cf3ae89fdf63cf/preview/assets/dragons/sky-cutter.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "SkyEmperor": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/2b973aae7f004a01acc25dc5b7e0326c/preview/assets/dragons/SkyEmperor.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "SkyRaptor": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/e4bb806470aa438c84ca56c03662457f/preview/assets/dragons/SkyRaptor.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "SolarDominion": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/2b973aae7f004a01acc25dc5b7e0326c/preview/assets/dragons/SolarDominion.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "SolarSeraph": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/89ae48217d1345f0a667415861203d6a/preview/assets/dragons/SolarSeraph.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "SparkFang": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/7bd34707ca4d4ef38b21a373cbaab8bc/preview/assets/dragons/spark-fang.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "StoneClaw": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/7bd34707ca4d4ef38b21a373cbaab8bc/preview/assets/dragons/stone-claw.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "StormColossus": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/2b973aae7f004a01acc25dc5b7e0326c/preview/assets/dragons/StormColossus.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "StormFeather": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/29c9debe2a3e4bd1a99b6d15919ceb62/preview/assets/dragons/storm-feather.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "StormGuard": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/d5b920595192477ca4cf3ae89fdf63cf/preview/assets/dragons/storm-guard.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "StormTitan": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/89ae48217d1345f0a667415861203d6a/preview/assets/dragons/StormTitan.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "SunFlare": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/d5b920595192477ca4cf3ae89fdf63cf/preview/assets/dragons/sun-flare.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "TempestSovereign": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/89ae48217d1345f0a667415861203d6a/preview/assets/dragons/TempestSovereign.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "TerraBehemoth": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/89ae48217d1345f0a667415861203d6a/preview/assets/dragons/TerraBehemoth.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "TerraTitan": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/2b973aae7f004a01acc25dc5b7e0326c/preview/assets/dragons/TerraTitan.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "ThunderBehemoth": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/e4bb806470aa438c84ca56c03662457f/preview/assets/dragons/ThunderBehemoth.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "ThunderDeity": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/2b973aae7f004a01acc25dc5b7e0326c/preview/assets/dragons/ThunderDeity.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "ThunderRoar": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/d5b920595192477ca4cf3ae89fdf63cf/preview/assets/dragons/thunder-roar.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "TidalCrusher": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/e4bb806470aa438c84ca56c03662457f/preview/assets/dragons/TidalCrusher.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "TideShield": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/7bd34707ca4d4ef38b21a373cbaab8bc/preview/assets/dragons/tide-shield.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "TitanCarapace": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/e4bb806470aa438c84ca56c03662457f/preview/assets/dragons/TitanCarapace.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "UmbraFang": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/e4bb806470aa438c84ca56c03662457f/preview/assets/dragons/UmbraFang.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "VoidSovereign": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/2b973aae7f004a01acc25dc5b7e0326c/preview/assets/dragons/VoidSovereign.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "VolcanicEmperor": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/89ae48217d1345f0a667415861203d6a/preview/assets/dragons/VolcanicEmperor.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "VoltClaw": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/29c9debe2a3e4bd1a99b6d15919ceb62/preview/assets/dragons/volt-claw.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "Water": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/c089f59db2a9432b8a66e4d03f491108/preview/assets/dragons/water.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "WaveRider": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/d5b920595192477ca4cf3ae89fdf63cf/preview/assets/dragons/wave-rider.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "WindBastion": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/29c9debe2a3e4bd1a99b6d15919ceb62/preview/assets/dragons/wind-bastion.png",
      "height": 100,
      "transparent": true,
      "width": 100
    },
    "WorldGuardian": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/2b973aae7f004a01acc25dc5b7e0326c/preview/assets/dragons/WorldGuardian.png",
      "height": 100,
      "transparent": true,
      "width": 100
    }
  },
  "icons": {
    "coin": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/c089f59db2a9432b8a66e4d03f491108/preview/assets/icons/coin.png",
      "height": 64,
      "transparent": true,
      "width": 64
    }
  },
  "logos": {
    "splash": {
      "path": "https://ucarecdn.com/dac37dfb-d2a9-4b0b-bf04-c86978ed718c/graph.svg",
      "width": 300,
      "height": 300
    }
  },
  "player": {
    "avatar": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/eab06c10a64e4f5a94d49fb5c6a31b9e/aa768a94b1024ea3b59c83a9fc7a45f5/preview/assets/competitors/Rookie.png",
      "height": 100,
      "width": 100
    }
  }
}
